/* eslint-disable no-console */
import { checkAvailability } from '../dealer-availability/dealer-lookup-form';
import { updateEmalSignupForm } from '../dealer-availability/email-signup-form';
import DealerAvailabilityModal from '../dealer-availability-modal';
import { addProductsFormGroup } from '../dealer-contact/share-products';
import { clearInputValues, removeAllErrors, resetSelectValues, validate } from '../../utils/form-validation-utils';
import { sendProductLeadToDrip } from '../drip-helpers';
import SiteModal from '../site-modal';

const clearDealerLoookupFormData = () => {
  const form = document.querySelector('.dealer-share-form');
  if (form) {
    removeAllErrors(form);
    clearInputValues(form);
    resetSelectValues(form);
  }
};

const addMultipleProductDealerShareModal = () => {
  const modalDiv = document.querySelector('.dealer-share-modal');
  if (!modalDiv) {
    return;
  }

  const updateModalHeight = () => {
    const contentHeight = modalDiv.querySelector('.modal-content').offsetHeight + 30;
    modalDiv.querySelector('.modal-panel').style.height = `${contentHeight}px`;
  };

  // Init modal
  const modal = new SiteModal({
    id: 'dealer-share-modal',
    callbacks: {
      onClose: () => {
        clearDealerLoookupFormData();
        resetDefaultState(); /* eslint-disable-line no-use-before-define */
      },
    },
  });
  // Add event listeners to all buttons that trigger the modal
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('share-with-dealer-btn')) {
      modal.open();
    }
  });
  // Add modal close events
  const continueShoppingBtn = modalDiv.querySelector('.close-share-modal-btn');
  if (continueShoppingBtn) {
    continueShoppingBtn.addEventListener('click', () => {
      modal.close();
    });
  }
  // Add resize listener
  window.addEventListener('resize', updateModalHeight);
  // Form
  const form = modalDiv.querySelector('.dealer-share-form');
  const zipIpt = form.querySelector('#Zip');
  const formError = form.querySelector('.form-error-message');
  const submitBtn = form.querySelector('.submit-btn');
  const formConfirmationDiv = modalDiv.querySelector('.form-submit-confirmation');
  addProductsFormGroup(form);

  const disableSubmitBtn = () => {
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.value = 'Sending...';
  };

  const enableSubmitBtn = () => {
    submitBtn.removeAttribute('disabled');
    submitBtn.value = 'Submit';
  };

  const showFormError = () => {
    formError.classList.remove('hidden');
    updateModalHeight();
    formError.focus();
  };

  const hideFormError = () => {
    formError.classList.add('hidden');
    updateModalHeight();
  };

  const resetDefaultState = () => {
    form.classList.remove('hidden');
    formConfirmationDiv.classList.add('hidden');
  };

  const showConfirmation = () => {
    form.classList.add('hidden');
    formConfirmationDiv.classList.remove('hidden');
    updateModalHeight();
    // Add close events
    const returnToFavoritesBtn = modalDiv.querySelector('.return-to-favorites-btn');
    if (returnToFavoritesBtn) {
      returnToFavoritesBtn.addEventListener('click', () => {
        modal.close();
      });
    }
  };

  const submitForm = () => {
    removeAllErrors(form);
    hideFormError();
    const { dealerAvailabilityCheckRadius } = window;
    if (validate(form)) {
      disableSubmitBtn();
      checkAvailability({
        address: zipIpt.value,
        radius: dealerAvailabilityCheckRadius,
        onDealerAvailable: () => {
          sendProductLeadToDrip(form);
          enableSubmitBtn();
          showConfirmation();
          updateModalHeight();
        },
        onDealerNotAvailable: () => {
          // Pass email address to email signup form
          const email = form.querySelector('#Email').value;
          updateEmalSignupForm({ email });
          DealerAvailabilityModal({
            state: 'dealer-not-available',
          });
          updateModalHeight();
          enableSubmitBtn();
        },
        onError: () => {
          enableSubmitBtn();
          showFormError();
        },
      });
    } else {
      updateModalHeight();
    }
  };

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    submitForm();
  });
};

export {
  addMultipleProductDealerShareModal,
  clearDealerLoookupFormData,
};
/* eslint-enable no-console */
